const cmToFeet = (cm: number): number => {
  return Math.floor((cm / 30.48) * 100) / 100;
};

export default cmToFeet;
